let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1XUYR")).then(() => parcelRequire('9JK3x'));